import { Context } from '@/models/order-history/status/context/context'
import { containNpCreditError, containNpProfileError } from '@/models/order-history/status/context/history-error/np-postpay'
import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { ForDefaultPaymentMethod } from '@spa/components/organisms/mypage/order/model/order-status-view/commands/for-default-payment-method'
import { CreateOrderStatusViewModelCommand } from '@spa/components/organisms/mypage/order/model/order-status-view/create-command'
import { orderStatusViewKinds } from '@spa/components/organisms/mypage/order/model/order-status-view/kind'

interface ApplicableContext extends Context {
  paymentType: 'np-postpay'
}

/**
 * @internal モジュールの外部からはcreateOrderStatusViewModelを利用すること
 */
export class ForNpPostpay extends CreateOrderStatusViewModelCommand<ApplicableContext> {
  shouldApply(context: Pick<Context, 'paymentType'>): context is ApplicableContext {
    return context.paymentType === 'np-postpay'
  }
  protected createViewModel(
    context: ApplicableContext
  ): OrderStatusViewModel {
    // デフォルトにフォールバックする
    const fallback = (c: Context) => new ForDefaultPaymentMethod().execute(c)

    switch (context.engineStatus) {
      case 'payment-requested':
        return orderStatusViewKinds.waitingForCreditExamination

      case 'payment-error':
        if (containNpProfileError(context.historyErrorList)) {
          return orderStatusViewKinds.npProfileErrorOccurred
        }

        if (containNpCreditError(context.historyErrorList)) {
          return orderStatusViewKinds.npCreditErrorOccurred
        }

        return fallback(context)

      case 'payment-fatal-error':
        return orderStatusViewKinds.reorderExpired

      default:
        return fallback(context)
    }
  }
}
